module.exports = __webpack_public_path__ + "static/img/3.3e0a87e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/zh/3.png
// module id = gUJF
// module chunks = 0